module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige4-266b585e5a5b395037e5cebd4c0d3b1f.jpg";